import { styled } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Stack from '@mui/material/Stack';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  flex: 1,
  paddingBlockStart: theme.spacing(6),
  paddingBlockEnd: theme.spacing(6),
  alignItems: 'flex-start',
  minHeight: theme.spacing(80),
}));

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  backgroundColor: theme.palette.background.tertiary,
  width: theme.spacing(6),
  height: theme.spacing(6),
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: theme.spacing(6),
}));

export const StyledWrapStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(3),
  flexWrap: 'wrap',
}));
